// Campo dinamico del form di progettazione (select, textarea, input) con visibilità condizionale
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Calculator } from 'lucide-react';

const FIELD_WIDTHS = {
  12: 'col-span-12',
  8: 'col-span-8',
  6: 'col-span-6',
  4: 'col-span-4',
  3: 'col-span-3',
};

export function FormField({ field, formData, onChange, readOnly }) {
  const value = formData[field.name] || '';
  const isReadOnly = readOnly || field.readonly;
  const isCalculated = field.calculated;

  // Visibilità condizionale
  if (field.conditional) {
    const conditionValue = field.conditional.value;
    const currentValue = formData[field.conditional.field];

    if (Array.isArray(conditionValue)) {
      if (!conditionValue.includes(currentValue)) return null;
    } else if (currentValue !== conditionValue) {
      return null;
    }
  }

  const fieldWidth = FIELD_WIDTHS[field.width] || 'col-span-6';

  return (
    <div className={fieldWidth}>
      <div className="space-y-1">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-medium">
            {field.label}
            {field.required && <span className="text-red-500 ml-1">*</span>}
          </Label>
          {isCalculated && (
            <Badge variant="outline" className="text-xs bg-blue-50 text-blue-700">
              <Calculator className="h-3 w-3 mr-1" />
              Auto
            </Badge>
          )}
        </div>

        {field.type === 'select' ? (
          <Select
            value={value}
            onValueChange={(v) => onChange(field.name, v)}
            disabled={isReadOnly}
          >
            <SelectTrigger className={isCalculated ? 'bg-blue-50' : ''}>
              <SelectValue placeholder={`Seleziona ${field.label.toLowerCase()}`} />
            </SelectTrigger>
            <SelectContent>
              {field.options?.map(opt => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : field.type === 'textarea' ? (
          <Textarea
            value={value}
            onChange={(e) => onChange(field.name, e.target.value)}
            disabled={isReadOnly}
            placeholder={field.placeholder}
            rows={3}
          />
        ) : (
          <Input
            type={field.type === 'number' ? 'number' : field.type === 'date' ? 'date' : 'text'}
            value={value}
            onChange={(e) => onChange(field.name, field.type === 'number' ? parseFloat(e.target.value) || '' : e.target.value)}
            disabled={isReadOnly}
            readOnly={isCalculated}
            placeholder={field.placeholder}
            min={field.min}
            max={field.max}
            step={field.step}
            className={isCalculated ? 'bg-blue-50 font-semibold' : isReadOnly ? 'bg-gray-50' : ''}
          />
        )}

        {field.help && (
          <p className="text-xs text-muted-foreground">{field.help}</p>
        )}
      </div>
    </div>
  );
}
